// removed by extract-text-webpack-plugin
module.exports = {"Register":"Register__Register__1yAe5"};


//////////////////
// WEBPACK FOOTER
// ./src/container/auth/register/Register.css
// module id = 6047
// module chunks = 0